/* eslint-disable react/jsx-props-no-spreading */
import { ReactNode } from 'react';
import styled from 'styled-components';

import { Link } from '@treams/treams-routes';

import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import { LinkTo } from 'packages/kakapo-ui-kit/types/Link';

export interface IElementProps {
	bordered?: boolean;
	grow?: boolean;
	backgroundColor?: string;
}

interface ILinkProps {
	to: LinkTo;
	target?: string;
}

const Element = styled.div<IElementProps>`
	background-color: ${(props) =>
		props.backgroundColor
			? props.theme.colors[props.backgroundColor]
			: props.theme.colors.lightBlueLight};
	border: ${(props) => (props.bordered ? `1px solid ${props.theme.colors.primary}` : 'none')};
	border-radius: 6px;
	width: 100%;
	@media print {
		padding: 15px 15px;
		background-color: white;
		border: 3px solid ${(props) => props.theme.colors.lightBlueLight};
	}
`;

const LinkElement = styled(Link)`
	& > div {
		transition: 300ms transform ease-out, 300ms box-shadow ease-out;
	}

	&:hover > div {
		transform: translateY(-3px);
		box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.1);
	}

	&:active > div {
		transform: none;
	}
`;

export const PlainHorizontalCardHeaderButton = styled.button`
	width: 30px;
	height: 30px;
	background-color: ${(props) => props.theme.colors.lightBlueDark};
	border-radius: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

interface IProps extends IElementProps {
	children: ReactNode;
	header?: ReactNode;
	padding?: PlainHorizontalCardPadding;
	my?: number;
	onClick?: () => void;
}

export enum PlainHorizontalCardPadding {
	None,
	Small,
	Large,
}

const paddings: Record<PlainHorizontalCardPadding, Array<number>> = {
	[PlainHorizontalCardPadding.None]: [0],
	[PlainHorizontalCardPadding.Small]: [2, 2, 3],
	[PlainHorizontalCardPadding.Large]: [2, 3, 4],
};

const PlainHorizontalCard = ({
	children,
	header,
	padding = PlainHorizontalCardPadding.Small,
	my,
	bordered,
	backgroundColor,
	grow,
	onClick,
}: IProps) => (
	<Element
		bordered={bordered}
		backgroundColor={backgroundColor}
		style={grow ? { height: '100%' } : {}}
		onClick={onClick}
	>
		<Column p={paddings[padding]} my={my}>
			{header}
			{children}
		</Column>
	</Element>
);

export const PlainHorizontalCardLink = ({
	to,
	target = '_self',
	grow,
	...props
}: IProps & ILinkProps) => (
	<LinkElement target={target} to={to} style={grow ? { display: 'block', height: '100%' } : {}}>
		<PlainHorizontalCard {...props} grow={grow} />
	</LinkElement>
);

export default PlainHorizontalCard;
